export default "__VITE_ASSET__0kY78BTw__"